import React, { createContext, useContext, useCallback, useRef, useMemo } from "react";
import { useDispatch } from "react-redux";
import {
  showSnackbar, hideSnackbar,
  showDialog, hideDialog,
  showLoader, hideLoader,
  setNotification
} from "../../../store/snpGlobalUISlice";
import GlobalUIManager from "./GlobalUIManager";

const SnpUIContext = createContext();

export const SnpUIProvider = ({ children }) => {
  const dispatch = useDispatch();
  const dialogCallbacksRef = useRef({});

  const snpUi = useMemo(() => ({
    snackbar: {
      show: (payload) => dispatch(showSnackbar(payload)),
      hide: () => dispatch(hideSnackbar())
    },
    loader: {
      show: () => dispatch(showLoader()),
      hide: () => dispatch(hideLoader())
    },
    dialog: {
      show: (payload) => {
        dialogCallbacksRef.current = {
          onConfirm: payload.onConfirmAction,
          onCancel: payload.onCancel,
        };
        const safePayload = { ...payload };
        delete safePayload.onConfirmAction;
        delete safePayload.onCancel;
        dispatch(showDialog(safePayload));
      },
      hide: () => {
        dispatch(hideDialog());
        dialogCallbacksRef.current = {};
      },
      getCallbacks: () => dialogCallbacksRef.current,
    },
    notify: {
      info: (title, body, cb) =>
        dispatch(setNotification({ title, body, type: 1, callback: cb })),
      warn: (title, body, cb) =>
        dispatch(setNotification({ title, body, type: 2, callback: cb })),
      error: (title, body, cb) =>
        dispatch(setNotification({ title, body, type: 3, callback: cb })),
    },
  }), [dispatch]); // Add any other dependencies you might mutate
  

  return (
    <SnpUIContext.Provider value={snpUi}>
      <GlobalUIManager />
      {children}
    </SnpUIContext.Provider>
  );
};

export const useSnpUI = () => useContext(SnpUIContext);
